import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-promociones-modal',
  templateUrl: './promociones-modal.component.html',
  styleUrls: ['./promociones-modal.component.scss']
})
export class PromocionesModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
